/** @jsxImportSource @emotion/react */
import React from "react";
import {Icon} from "@blueprintjs/core";

// Libs
import {primaryColor, successColor} from "../libs/theme-lib";

const Button = (props) => {
    const {text, action, intent, icon, style, disabled = true} = props;
    return (
        <div style={style}>
            {!!disabled ?
                <div
                    css={{
                        padding: "12px 24px",
                        textAlign: "center",
                        transition: "all 0.4s",
                        display: "flex",
                        justifyContent: "center",
                        "&:hover": {
                            cursor: "pointer"
                        },
                        ...(intent && intents[intent]) || intents.default
                    }}
                    onClick={action}
                >
                    {!!icon && (
                        <div>
                            <Icon icon={icon} style={{ marginRight: 5 }} />
                        </div>
                    )}
                    {!!text && (
                        <div>
                            {text}
                        </div>
                    )}
                </div> :
                <div
                    css={{
                        padding: "12px 24px",
                        textAlign: "center",
                        transition: "all 0.4s",
                        "&:hover": {
                            cursor: "not-allowed"
                        },
                        ...disabledStyle
                    }}
                >
                    {!!icon && (
                        <div>
                            <Icon icon={icon} style={{ ...text ? { marginRight: 5 } : null }} />
                        </div>
                    )}
                    {!!text && (
                        <div>
                            {text}
                        </div>
                    )}
                </div>
            }
        </div>
    );
};

export default Button;

const intents = {
    default: {
        color: "white",
        backgroundColor: "black",
        "&:hover": {
            color: primaryColor
        }
    },
    primary: {
        color: "white",
        backgroundColor: primaryColor
    },
    cancel: {
        backgroundColor: "#d9d9d9",
        color: "#333"
    },
    secondary: {
        backgroundColor: successColor,
        color: "white"
    },
    red: {
        backgroundColor: "#E2271D",
        color: "white"
    }
};

const disabledStyle = {
    backgroundColor: "#d9d9d9",
    color: "black"
};